<template lang="html">
    <Container name="whatisthis">
      <div class="text-container">
        <p class="text"><slot /></p>
      </div>
    </Container>
</template>

<script>
import Container from '../components/Container.vue'

export default {
  components: { Container }
}
</script>

<style lang="css" scoped>
  @media screen and (max-width: 800px) {
    .text-container {
      font-size: 20px;
    }
  }
  @media screen and (min-width: 800px) {
    .text-container {
      font-size: 27px;
    }
    .text {
      max-width: 30em;
    }
  }
  .text-container {
    /* width: 100%; */
    /* padding: 8%; */
    padding: 100px 8%;
    line-height: 180%;
  }
  .text {
    /* border: 1px solid red; */
    width: 100%;
    margin: auto;
    /* padding: 0 20px; */
  }
</style>
